import template from './bargain-allowed.jade';

export default angular
  .module('cian.addForm.bargainAllowed', [])
  .directive('cianAfPriceAndDealTermsBargainAllowed', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      function () {
        const isBargainAllowed = () => {
          return (
            this.ad.bargainTerms.bargainAllowed ||
            (angular.isDefined(this.ad.bargainTerms.bargainPrice) && this.ad.bargainTerms.bargainPrice !== null) ||
            angular.isString(this.ad.bargainTerms.bargainConditions)
          );
        };

        this.ad.bargainTerms = this.ad.bargainTerms || {};
        this.ad.bargainTerms.bargainAllowed = isBargainAllowed();
      },
    ],
    controllerAs: 'bargainAllowed',
    template,
  })).name;
